module.exports = __webpack_public_path__ + "static/img/4_2.299b0b67.jpg";